import { UrlSegment } from '@angular/router';

/**
 * Where the login legal documents packet is presented.
 *
 * Lives in this library because all three sequencing guards on the `home` route need it:
 * `loginLegalDocsMatchGuard` (shared/legal-documents), `eligibilityDataCollectMatchGuard`
 * (here), and `onboardingMatchCompleteGuard` (desktop/feature/onboarding2). Both of the
 * others already depend on this library, and it depends on neither.
 */
export const LOGIN_LEGAL_DOCS_PATH = ['home', 'legal'];

/**
 * True when the navigation being matched is the login legal documents screen itself.
 *
 * The sequencing guards on `home` use this to let it through rather than redirecting it
 * away: login terms are collected first, and the legal screen must not be redirected into
 * itself.
 */
export const isLoginLegalDocsPath = (segments: UrlSegment[]): boolean =>
  segments.length === LOGIN_LEGAL_DOCS_PATH.length &&
  segments.every((segment, index) => segment.path === LOGIN_LEGAL_DOCS_PATH[index]);
